module.exports = __webpack_public_path__ + "036c8408bed37beaa4e15174d7987d6e.png";